import { render, staticRenderFns } from "./MyModificationOrder.vue?vue&type=template&id=5a25db9e&scoped=true"
import script from "./MyModificationOrder.vue?vue&type=script&lang=js"
export * from "./MyModificationOrder.vue?vue&type=script&lang=js"
import style0 from "./MyModificationOrder.vue?vue&type=style&index=0&id=5a25db9e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a25db9e",
  null
  
)

export default component.exports